var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYesJobInfo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 14.4001C11.5347 14.4001 14.4001 11.5347 14.4001 8.0001C14.4001 4.46548 11.5347 1.6001 8.0001 1.6001C4.46548 1.6001 1.6001 4.46548 1.6001 8.0001C1.6001 11.5347 4.46548 14.4001 8.0001 14.4001Z",
    fill: "#37AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16209 10.5525C7.09077 10.5526 7.02016 10.5384 6.95437 10.5109C6.88858 10.4833 6.82894 10.443 6.77894 10.3921L4.79579 8.37737C4.69587 8.27553 4.64051 8.13817 4.64187 7.9955C4.64323 7.85283 4.7012 7.71655 4.80304 7.61663C4.90489 7.51671 5.04225 7.46134 5.18492 7.4627C5.32758 7.46406 5.46388 7.52204 5.5638 7.62388L7.14502 9.23327L10.4227 5.62367C10.5198 5.52332 10.6522 5.46471 10.7918 5.46024C10.9313 5.45576 11.0672 5.50578 11.1705 5.5997C11.2739 5.69363 11.3366 5.82409 11.3455 5.96347C11.3543 6.10284 11.3086 6.2402 11.218 6.34645L7.55889 10.3767C7.50984 10.4309 7.45027 10.4745 7.38381 10.5049C7.31735 10.5352 7.24538 10.5517 7.17233 10.5534L7.16209 10.5525Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYesJobInfo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/yes_job_info.3ed19636.svg";
export { ForwardRef as ReactComponent };